/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import {
  Box,
  Flex,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
} from '@tonic-one/react';
import isEqual from 'lodash/isEqual';
import React, { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import ButtonTab from 'src/components/Common/ButtonTab';
import { TitleLabel } from 'src/components/Common/FormComponent';
import NotifyAdmin from 'src/components/FilterNotification/NotifyAdmin';
import NotifyUser from 'src/components/FilterNotification/NotifyUser';
import {
  EnableDisableStatus,
  ExchangeOnlinePolicyItem,
} from 'src/pages/Policy/utils/types';
import { useWhyDidYouUpdate } from 'src/utils/hooks';

import {
  storeSelector,
  templateSelector,
  usePolicyContext,
} from '@Policy/store';
import { PolicyModeEnum } from '@Policy/utils/constants';
import Actions from '../../Components/Actions';
import { asActionDataSelector } from '@Policy/store/filters/advancedSpamProtection';
export const AsAction = () => {
  // get store from context
  const contextStore = usePolicyContext();
  // get store selector
  const contextSelector = storeSelector(contextStore);
  const policySelector = templateSelector(contextStore);
  const policyMode = policySelector((s) => s.policyMode);
  // get data by selector from store
  const actionData = contextSelector(asActionDataSelector, isEqual);
  useWhyDidYouUpdate('Antispam AsAction', {
    actionData,
  });
  return (
    <Actions
      actionData={actionData}
      disabledAll={policyMode === PolicyModeEnum.DefaultMonitorPolicy}
    />
  );
};
export const AsNotification = () => {
  const { t } = useTranslation();
  // get store from context
  const contextStore = usePolicyContext();
  const policySelector = templateSelector(
    contextStore
  )<ExchangeOnlinePolicyItem>;
  // get store selector
  const contextSelector = storeSelector(contextStore);
  // get state and action from store
  const ntfAdminIntervalNum = policySelector(
    (s) => s.tmAntispamfilters.notification.ntfAdminIntervalNum
  );
  const ntfAdminIntervalType = policySelector(
    (s) => s.tmAntispamfilters.notification.ntfAdminIntervalType
  );
  const ntfAdminMessage = policySelector(
    (s) => s.tmAntispamfilters.notification.ntfAdminMessage
  );
  const ntfAdminNotifySettingType = policySelector(
    (s) => s.tmAntispamfilters.notification.ntfAdminNotifySettingType
  );
  const ntfAdminSubject = policySelector(
    (s) => s.tmAntispamfilters.notification.ntfAdminSubject
  );
  const ntfEnableNotifyAdmin = policySelector(
    (s) => s.tmAntispamfilters.notification.ntfEnableNotifyAdmin
  );
  const ntfEnableNotifyRecipient = policySelector(
    (s) => s.tmAntispamfilters.notification.ntfEnableNotifyRecipient
  );
  const ntfInternalRecipientMessage = policySelector(
    (s) => s.tmAntispamfilters.notification.ntfInternalRecipientMessage
  );
  const ntfInternalRecipientSubject = policySelector(
    (s) => s.tmAntispamfilters.notification.ntfInternalRecipientSubject
  );
  const ntfToAccount = policySelector(
    (s) => s.tmAntispamfilters.notification.ntfToAccount
  );
  const ntfAdminOccurenceNum = policySelector(
    (s) => s.tmAntispamfilters.notification.ntfAdminOccurenceNum
  );
  const ntfRecipientGroupId = policySelector(
    (s) => s.tmAntispamfilters.notification.ntfRecipientGroupId
  );
  const ntfRecipientGroupEnabled = policySelector(
    (s) => s.tmAntispamfilters.notification.ntfRecipientGroupEnabled
  );
  const recipientGroups = contextSelector((s) => s.recipientGroups);
  const setAsNtfState = contextSelector((s) => s.setAsNtfState);

  // local state
  const handleNtfEnableAdminChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      setAsNtfState({
        ntfEnableNotifyAdmin: e.target.checked ? 1 : 0,
      });
    },
    []
  );
  const handleNtfAdminToAccountChange = useCallback((toAccount: string) => {
    setAsNtfState({ ntfToAccount: toAccount });
  }, []);
  const handleNtfAdminNotifySettingTypeChange = useCallback(
    (notifySettingType: number) => {
      setAsNtfState({
        ntfAdminNotifySettingType: notifySettingType,
      });
    },
    []
  );
  const handleNtfAdminSubjectChange = useCallback((subject: string) => {
    setAsNtfState({ ntfAdminSubject: subject });
  }, []);
  const handleNtfAdminMessageChange = useCallback((message: string) => {
    setAsNtfState({ ntfAdminMessage: message });
  }, []);
  const handleNtfAdminIntervalNumChange = useCallback((intervalNum: number) => {
    setAsNtfState({ ntfAdminIntervalNum: intervalNum });
  }, []);
  const handleNtfAdminIntervalTypeChange = useCallback(
    (intervalType: number) => {
      setAsNtfState({ ntfAdminIntervalType: intervalType });
    },
    []
  );
  const handleNtfAdminOccurenceNumChange = useCallback(
    (occurenceNum: number) => {
      setAsNtfState({ ntfAdminOccurenceNum: occurenceNum });
    },
    []
  );
  const handleNtfRecipientGroupIdChange = useCallback(
    (recipientGroupId: number) => {
      setAsNtfState({ ntfRecipientGroupId: recipientGroupId });
    },
    []
  );
  const handleNtfRecipientGroupEnabledChange = useCallback(
    (enabled: EnableDisableStatus) => {
      setAsNtfState({ ntfRecipientGroupEnabled: enabled });
    },
    []
  );
  const handleNtfEnableRecipientChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      setAsNtfState({
        ntfEnableNotifyRecipient: e.target.checked ? 1 : 0,
      });
    },
    []
  );
  const handleNtfInternalRecipientSubjectChange = useCallback(
    (subject: string) => {
      setAsNtfState({ ntfInternalRecipientSubject: subject });
    },
    []
  );
  const handleNtfInternalRecipientMessageChange = useCallback(
    (message: string) => {
      setAsNtfState({ ntfInternalRecipientMessage: message });
    },
    []
  );
  useWhyDidYouUpdate('Antispam AsNotification', {
    ntfAdminIntervalNum,
    ntfAdminIntervalType,
    ntfAdminMessage,
    ntfAdminNotifySettingType,
    ntfAdminSubject,
    ntfEnableNotifyAdmin,
    ntfEnableNotifyRecipient,
    ntfInternalRecipientMessage,
    ntfInternalRecipientSubject,
    ntfToAccount,
    ntfAdminOccurenceNum,
    ntfRecipientGroupId,
    recipientGroups,
  });
  return (
    <Tabs mt="24px">
      <TabList>
        <ButtonTab>{t('policy.notification.admin')}</ButtonTab>
        <ButtonTab>{t('policy.notification.user')}</ButtonTab>
      </TabList>
      <TabPanels py="24px">
        <TabPanel>
          <NotifyAdmin
            status={ntfEnableNotifyAdmin}
            toAccount={ntfToAccount}
            notifySettingType={ntfAdminNotifySettingType}
            subject={ntfAdminSubject}
            message={ntfAdminMessage}
            intervalNum={ntfAdminIntervalNum}
            intervalType={ntfAdminIntervalType}
            occurenceNum={ntfAdminOccurenceNum}
            recipientGroupId={ntfRecipientGroupId}
            recipientGroups={recipientGroups}
            recipientGroupEnabled={ntfRecipientGroupEnabled}
            setStatus={handleNtfEnableAdminChange}
            setToAccount={handleNtfAdminToAccountChange}
            setNotifySettingType={handleNtfAdminNotifySettingTypeChange}
            setSubject={handleNtfAdminSubjectChange}
            setMessage={handleNtfAdminMessageChange}
            setIntervalNum={handleNtfAdminIntervalNumChange}
            setIntervalType={handleNtfAdminIntervalTypeChange}
            setOccurenceNum={handleNtfAdminOccurenceNumChange}
            setRecipientGroupId={handleNtfRecipientGroupIdChange}
            setRecipientGroupEnabled={handleNtfRecipientGroupEnabledChange}
          />
        </TabPanel>
        <TabPanel>
          <NotifyUser
            status={ntfEnableNotifyRecipient}
            subject={ntfInternalRecipientSubject}
            message={ntfInternalRecipientMessage}
            setStatus={handleNtfEnableRecipientChange}
            setSubject={handleNtfInternalRecipientSubjectChange}
            setMessage={handleNtfInternalRecipientMessageChange}
          />
        </TabPanel>
      </TabPanels>
    </Tabs>
  );
};

function ActionNotification() {
  const { t } = useTranslation();

  return (
    <div>
      <Box ml="1px" mt="16px" width="100%">
        <Flex direction="column">
          <TitleLabel title={t('policy.action')} mb="24px" />
          <AsAction />
          <TitleLabel title={t('policy.notification')} mt="40px" />
          <AsNotification />
        </Flex>
      </Box>
    </div>
  );
}

export default React.memo(ActionNotification);
